var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top',{attrs:{"title":_vm.getTopTitle()}}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view',{staticStyle:{"padding-top":"2.5rem"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34358638","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/layer2/books/index.vue
// module id = null
// module chunks = 